import { createCardGridSlide } from '../helpers/card_grid_slide';
import { createImageSlide } from '../helpers/image_slide';
import { createTableSlide } from '../helpers/table_slide';
import { createTakeawaysSlide } from '../helpers/takeaways_slide';
import { createTornadoChartSlide } from '../helpers/chart_slide';
import { createTreeSlide } from '../helpers/tree_slide';
import { createWaterfallSlide } from '../helpers/waterfall_slide';
import { PRESENTATION_SLIDE_KINDS } from '../model';
import { renderChartSlide } from './chart';
import { renderMetadataSlide } from './metadata';
import { renderTextSlide } from './text';

const renderCardsSlide = ({ footer, pptx, slide }) =>
  createCardGridSlide({
    ...footer,
    cards: slide.cards,
    columns: slide.columns,
    fitOnSingleSlide: slide.fitOnSingleSlide,
    pptx,
    slideTitle: slide.title,
  });

const renderImageSlide = ({ footer, pptx, slide }) =>
  createImageSlide({
    ...footer,
    imageData: slide.data,
    imageOptions: slide.placement,
    pptx,
    readAs: slide.insight,
    slideTitle: slide.title,
  });

const renderTableSlide = ({ footer, pptx, slide }) =>
  createTableSlide({
    ...footer,
    pptx,
    readAs: slide.insight,
    slideTitle: slide.title,
    table: {
      columns: slide.columns.map(({ format, header, key }) => ({
        accessor: key,
        format,
        Header: header,
      })),
      data: slide.rows,
    },
  });

const renderTakeawaysSlide = ({ footer, pptx, slide }) =>
  createTakeawaysSlide({
    ...footer,
    body: slide.body,
    pptx,
    slideTitle: slide.title,
  });

const renderTornadoSlide = ({ footer, pptx, slide }) =>
  createTornadoChartSlide({
    ...footer,
    chart: {
      format: slide.valueFormat,
      series: slide.series.map(({ name, values }) => ({ data: values, name })),
      xAxis: { categories: slide.categories },
    },
    pptx,
    slideTitle: slide.title,
  });

const renderTreeSlide = ({ footer, pptx, slide }) =>
  createTreeSlide({
    ...footer,
    connectors: slide.connectors,
    insight: slide.insight,
    nodes: slide.nodes.map(({ id, ...node }) => ({ ...node, nodeId: id })),
    pptx,
    slideTitle: slide.title,
  });

const renderWaterfallSlide = ({ footer, pptx, slide }) =>
  createWaterfallSlide({
    ...footer,
    categories: slide.categories,
    format: slide.valueFormat,
    labels: slide.labels,
    pptx,
    series: slide.series,
    slideTitle: slide.title,
  });

const RENDERERS = {
  [PRESENTATION_SLIDE_KINDS.CARDS]: renderCardsSlide,
  [PRESENTATION_SLIDE_KINDS.CHART]: renderChartSlide,
  [PRESENTATION_SLIDE_KINDS.IMAGE]: renderImageSlide,
  [PRESENTATION_SLIDE_KINDS.METADATA]: renderMetadataSlide,
  [PRESENTATION_SLIDE_KINDS.TABLE]: renderTableSlide,
  [PRESENTATION_SLIDE_KINDS.TAKEAWAYS]: renderTakeawaysSlide,
  [PRESENTATION_SLIDE_KINDS.TEXT]: renderTextSlide,
  [PRESENTATION_SLIDE_KINDS.TORNADO]: renderTornadoSlide,
  [PRESENTATION_SLIDE_KINDS.TREE]: renderTreeSlide,
  [PRESENTATION_SLIDE_KINDS.WATERFALL]: renderWaterfallSlide,
};

export const renderPresentationSlide = async ({ footer, pptx, slide }) => {
  const renderer = RENDERERS[slide.kind];
  if (!renderer) throw new TypeError(`Unsupported canonical slide kind: ${slide.kind}`);
  return await renderer({ footer, pptx, slide });
};
